import { Component } from "@angular/core";
import { NavbarComponent } from "../../_components/navbar/navbar.component";
import { EasterHeaderComponent } from "./header/easter-header.component";
import { EasterSingleVideoComponent } from "./single-video/single-video.component";
import { EasterProductDisplayComponent } from "./product-display/product-display.component";
import { HomeValuePropComponent } from "../home/value-prop/value-prop.component";
import { EasterReviewsComponent } from "./reviews/reviews.component";
import { EasterTestimonialsComponent } from "./testimonials/testimonials.component";
import { EasterTncComponent } from "./tnc/tnc.component";
import { EasterFaqComponent } from "./faq/faq.component";
import { FooterComponent } from "../../../_components/footer/footer.component";
import { Meta, Title } from "@angular/platform-browser";

@Component({
    selector: 'app-v4-easter',
    imports: [NavbarComponent, EasterHeaderComponent, EasterSingleVideoComponent, EasterProductDisplayComponent, HomeValuePropComponent, EasterReviewsComponent, EasterTestimonialsComponent, EasterTncComponent, EasterFaqComponent, FooterComponent],
    template: `
     <app-v4-navbar></app-v4-navbar>
     <app-easter-header></app-easter-header>
     <app-easter-single-video></app-easter-single-video>
     <app-v4-home-value-prop [bgColor]="'tw-bg-v4-yellow-1'" [upperShadow]="true"></app-v4-home-value-prop>
     <app-easter-product-display [title]="'PORCELAIN PAVING'" [productList]="procelainProds"></app-easter-product-display>
     <app-easter-product-display [title]="'SANDSTONE PAVING'" [productList]="naturalStoneProds"></app-easter-product-display>
     <app-easter-product-display [title]="'GARDEN FURNITURE'" [productList]="gardenFurnitureProds"></app-easter-product-display>
     <app-easter-product-display [title]="'FIREPLACES'" [productList]="fireplaceProds"></app-easter-product-display>
     <app-easter-product-display [title]="'PLANTERS'" [productList]="planterProds"></app-easter-product-display>
     <app-easter-reviews></app-easter-reviews>
     <app-easter-faq></app-easter-faq>
     <!-- <app-easter-testimonials></app-easter-testimonials> -->
     <app-easter-tnc></app-easter-tnc>
     <app-footer></app-footer>
  `
})
export class EasterComponent {
    procelainProds = [
        'kandla-grey-porcelain-paving-600x900',
        'kandla-grey-outdoor-porcelain-paving-tiles-600x600',
        'raj-green-porcelain-patio-kit',
        'ash-grey-wood-outdoor-porcelain-paving-tiles',
        'ash-haze-outdoor-porcelain-paving-tiles',
        'charcoal-haze-outdoor-porcelain-paving-tiles',
        'taupe-haze-outdoor-porcelain-paving-tiles',
        'maple-wood-outdoor-porcelain-paving-tiles',
        'golden-dune-outdoor-porcelain-paving-tiles-600x900-20mm'
    ];
    naturalStoneProds = [
        'autumn-brown-sandstone-paving-patio-kit-calibrated-22mm',
        'blue-black-granite-paving-600x600',
        'blue-black-slate-paving-600x600',
        'blue-black-granite-paving-patio-kit',
        'rippon-buff-sandstone-patio-kit',
        'rippon-buff-sawn-sandstone-patio-kit',
        'brazilian-black-slate-paving-patio-kit',
        'kandla-grey-indian-sandstone-paving1200x600',
        'rippon-buff-indian-sandstone-paving-slabs-riven-600x900-22mm',
        'rippon-buff-indian-sandstone-sawn-honed-bullnose-steps-900x400-40mm',
        'sawn-mint-indian-sandstone-paving-slabs-600x295',
        'rainbow-indian-sandstone-paving-600x600',
        'rainbow-indian-sandstone-paving-slabs-600x900',
        'raj-green-indian-sandstone-paving-slabs-tumbled-600x290',
        'raj-green-indian-sandstone-paving-slabs-tumbled-290x290',
        'raj-green-indian-sandstone-paving-slabs-riven-600x290',
        'kandla-grey-indian-sandstone-paving-slabs-riven-600x290',
        'fossil-mint-indian-sandstone-paving-slabs-riven-290x290',
        'kandla-grey-indian-sandstone-paving-slabs-tumbled-600x600',
        'rippon-buff-indian-sandstone-paving-slabs-riven-290x290',
        'kotah-black-limestone-setts-200x100',
        'sawn-mint-indian-sandstone-bullnose-step-corners'
    ];
    gardenFurnitureProds = [
        '2-seat-rattan-garden-furniture-bistro-set-black',
        '2-seater-rattan-garden-furniture-sofa-lounging-set',
        '3-seater-rattan-garden-furniture-sofa-lounging-set-2',
        '2-seater-rattan-garden-furniture-sofa-lounging-set-with-2-armchairs-and-coffee-table-brown',
        '2-seater-rattan-garden-furniture-sofa-lounging-set-with-2-armchairs-and-coffee-table',
        '2-seat-rattan-garden-furniture-bistro-set-brown',
        'l-shaped-corner-rattan-garden-furniture-lounge-dining-set-with-rising-dining-table',
        'l-shaped-corner-rattan-garden-furniture-lounge-dining-set-black',
        'rattan-garden-furniture-set-with-fire-pit-table',
        'df-04'
    ];
    fireplaceProds = [
        'carnell-bioethanol-patio-heater',
        'breton-bioethanol-patio-heater',
        'bernard-bioethanol-patio-heater',
        'newell-bioethanol-patio-heater',
        'rollins-bioethanol-patio-heater',
        'terrill-bioethanol-patio-heater'
    ];
    planterProds = [
        'bastet-stone-cat-planters',
        'colossal-planters',
        'eclipse-head-planters',
        'kew-planters',
        'athens-planter',
        'dalby-planters',
        'lilie-planters',
        'poise-planter',
        'pisa-planter',
        'refined-planters',
        'hive-planter',
        'mason-planters',
        'ash-planter',
        'nile-planter'
    ];

    constructor(
        private meta: Meta,
        private title: Title
    ) { }

    ngOnInit(): void {
        this.title.setTitle('Nustone Easter Sale – Flat 10% Off Your Entire Order | Nustone');
        this.meta.addTag({ name: 'description', content: 'Save 10% on your entire order at Nustone’s Easter Sale. Use code EASTER10 at checkout. Valid on paving, garden furniture, fireplaces, planters and more. Minimum order £1,000. Ends 19 April 2026.' });
        this.meta.addTag({ name: 'og:title', content: 'Nustone Easter Sale – Flat 10% Off Your Entire Order | Nustone' });
        this.meta.addTag({ name: 'og:description', content: 'Save 10% on your entire order at Nustone’s Easter Sale. Use code EASTER10 at checkout. Valid on paving, garden furniture, fireplaces, planters and more. Minimum order £1,000. Ends 19 April 2026.' });
    }
}
